/**
 * Today's date as YYYY-MM-DD in Ulaanbaatar time (UTC+8, no DST). `new Date().toISOString()` is UTC,
 * so between 00:00 and 08:00 in Ulaanbaatar it still names yesterday (O117).
 */
export function todayInUlaanbaatar(now: Date = new Date()): string {
  return new Intl.DateTimeFormat("en-CA", {
    timeZone: "Asia/Ulaanbaatar",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).format(now)
}

/**
 * Planned date + target departure time ("HH:mm", Ulaanbaatar local) -> ISO datetime for the route's
 * `plannedStartTime`. Empty time -> null (the BE accepts null).
 */
export function plannedStartIso(date: string | null, time: string | null): string | null {
  if (!date || !time || !/^\d{2}:\d{2}$/.test(time)) return null
  const parsed = new Date(`${date}T${time}:00+08:00`)
  return Number.isNaN(parsed.getTime()) ? null : parsed.toISOString()
}
